<template>
  <div class="text-content markdown-body">
    <div ref="markdownContent" v-highlight v-html="renderedMarkdown" />
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it'

export default {
  components: {},
  props: {
    source: {
      type: String,
      default: ''
    },
    citationsData: {
      type: Object,
      default: () => ({})
    },
    messageId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    renderedMarkdown() {
      // 先解析 Markdown
      let rendered = this.md.render(this.source)

      // 然后处理引用标记
      rendered = this.processCitations(rendered)

      // 在下一个 tick 初始化引用弹出框功能
      this.$nextTick(() => {
        if (this.$refs.markdownContent) {
          // 将引用数据传递给弹出框管理器
          this.messageId &&
            this.$initCitationPopovers(
              this.$refs.markdownContent,
              this.citationsData,
              this.messageId
            )
        }
      })

      return rendered
    }
  },
  watch: {
    // 当引用数据变化时重新渲染
    citationsData: {
      handler() {
        // 在下一个tick更新引用数据
        this.$nextTick(() => {
          if (this.$refs.markdownContent) {
            this.$initCitationPopovers(
              this.$refs.markdownContent,
              this.citationsData,
              this.messageId
            )
          }
        })
      },
      deep: true
    }
  },
  created() {
    this.md = new MarkdownIt({
      html: true, // 启用 HTML 标签渲染
      breaks: true, // 转换换行符为 <br>
      linkify: false // 自动将 URL 转换为链接
    })
  },
  methods: {
    // 处理引用标记
    processCitations(html) {
      // console.log(this.messageId, 'this.messageId090909090000000000---------')
      // 使用正则表达式查找引用标记 [citation:数字]
      return html.replace(/\[citation:(\d+)\]/g, (match, number) => {
        // 返回引用组件的 HTML，添加完整的内联样式
        return `<span class="citation-wrapper" style="position:relative;display:inline-block;margin:0 2px;z-index:6000;">
          <span class="ai-au"
                data-citation="${number}"
                data-message-id="${this.messageId}"
                style="cursor:pointer;display:inline-block;vertical-align:text-bottom;width:20px;height:20px;line-height:20px;text-align:center;color:#3a7fff;font-family:'PingFang SC';font-size:14px;font-weight:500;background:#F4F4F4;border-radius:50%;position:relative;z-index:6000;">${number}</span>
        </span>`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.text-content {
  &::-webkit-scrollbar {
    width: 1px;
  }
  &::-webkit-scrollbar-track {
    background: null;
  }
  &::-webkit-scrollbar-thumb {
    background: #c2d9ff;
  }
  .markdownBox::v-deep {
  }
}
.markdown-body::v-deep {
  > p:nth-last-of-type(1) {
    margin: 0 !important;
  }
  table {
    margin-top: 10px !important;
    border-radius: 10px;
    color: #000000;
    max-height: 600px;
    overflow-y: auto;
    thead {
      font-size: 14px;
      font-weight: 700;
      tr {
        background-color: #f2f2f2;
      }
    }
  }
  ul {
    li::before {
      content: '\2022'; /* 使用 Unicode 或其他字符表示小点 */
      color: #3a7fff; /* 设置小点颜色 */
      display: inline-block; /* 使小点与文本在同一行 */
      width: 1em; /* 调整小点的宽度，以适应需要的大小 */
      font-size: 14px;
      line-height: 1.5;
      margin-left: -1em; /* 负的左边距使小点与文本对齐 */
    }
  }
  ol > li::marker {
    color: #3a7fff;
  }
  pre {
    font-size: 70%;
  }
  h3 {
    font-size: 20px;
  }
}
</style>
